import {ClassToJson, SelectContentHandleClick} from 'helpers-ga4';

const ga4EventOnFilter = () => {
  const gridCollection = document.querySelectorAll(
    '#ProductGridContainer .collection .grid__item',
  );

  const collectionProducts = Array.from(gridCollection).map((item) => ({
    item_id: item.dataset.id,
    item_name: item.dataset.name,
    item_brand: item.dataset.brand,
    item_category: item.dataset.category,
    item_variant: item.dataset.variant,
    price: item.dataset.price,
    index: item.dataset.index,
    item_list_id: item.dataset.itemListId,
    item_list_name: item.dataset.itemListName,
  }));

  const parentObject = {
    event: 'view_item_list',
    event_params: {
      ecommerce: {
        item_list_id: `${MAIN_COLLECTION_GA4_OBJ.id}`,
        item_list_name: `${MAIN_COLLECTION_GA4_OBJ.name}`,
        items: collectionProducts,
      },
    },
  };

  // Use window.ExecuteGA4Event to ensure it's available globally
  if (typeof window !== 'undefined' && window.ExecuteGA4Event) {
    window.ExecuteGA4Event(ClassToJson(parentObject));
  } else {
    console.error(
      'ExecuteGA4Event is not available. Make sure global.js is loaded before this module.',
    );
  }
};

document.addEventListener('DOMContentLoaded', () => {
  // GA4 'view_item_list' event
  // Execute on page load
  const observer = new MutationObserver(() => {
    if (document.querySelector('#ProductGridContainer')) {
      ga4EventOnFilter();
      observer.disconnect();
    }
  });
  observer.observe(document.body, {childList: true, subtree: true});

  // When adding filters
  const facets = document.querySelector('.facets-wrapper');
  let loading = false;

  if (facets) {
    facets.addEventListener('click', function () {
      if (!loading) {
        loading = true;
        setTimeout(() => {
          const shadow = document.querySelectorAll('.show_placeholder');
          const srOnly = document.querySelector('.sr-only');
          shadow.forEach((item) => {
            item.classList.remove('show_placeholder');
            const link = item.querySelector('a');
            link.addEventListener('click', SelectContentHandleClick);
          });
          if (srOnly) srOnly.textContent = 'Products loaded';
          loading = false;
          ga4EventOnFilter();
        }, 3500);
      }
    });
  }
});
